import React, { useState } from 'react';
import { Alert, Button, CardContent, CardHeader, Typography } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import { useDispatch } from 'react-redux';
import { deleteLocation } from '../../../Redux/Action';
import { setModal } from '../../../../../Common/App';
import { DialogCard } from '../../../../../../Components/Cards/DialogCard';
import { Loader } from '../../../../../../Components';

export const DeleteLocationModal = ({ location, venueName }) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {

        if (!location?.id) {
            return;
        }

        setIsLoading(true);
        await deleteLocation({ dispatch, id: location.id }).then((res) => {
            if (res.success) {
                dispatch(setModal({ component: null, open: false }));
            }
            setIsLoading(false);
        });
    };

    return (
        <DialogCard>
            <CardHeader
                title="Delete Location"
                avatar={<Loader isLoading={isLoading} type="linear" />}
            />
            <CardContent sx={{ p: 2, pt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    You are about to delete the location <strong>&quot;{location?.location_name}&quot;</strong>
                    {venueName ? (
                        <> under venue <strong>&quot;{venueName}&quot;</strong></>
                    ) : null}.
                </Typography>
                <Alert severity="warning">
                    This action cannot be undone. Are you sure?
                </Alert>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2, justifyContent: 'flex-end' }}>
                <Button onClick={() => dispatch(setModal({ component: null, open: false }))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color="error" onClick={handleSubmit}>
                    Delete
                </Button>
            </DialogActions>
        </DialogCard>
    );
};
